export default {
    currentTelephoneBoxSelect: null
}